/**
 * SubmitButton Component
 * Variant-aware submit action.
 */

import { useTranslation } from 'react-i18next'
import { cn } from '../../../lib/utils'
import { Check, Loader2 } from 'lucide-react'
import { motion } from 'framer-motion'
import { QUIZ_BUTTON_STYLES } from './quiz-styles'
import { useQuizStyleVariant } from './quiz-style-context'

interface SubmitButtonProps {
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
  label?: string
  className?: string
}

export function SubmitButton({
  onClick,
  disabled = false,
  isLoading = false,
  label,
  className,
}: SubmitButtonProps) {
  const { t } = useTranslation('quiz')
  const variant = useQuizStyleVariant()
  const styles = QUIZ_BUTTON_STYLES[variant]
  const buttonLabel = label ?? t('common.checkAnswer')

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={cn('mt-6 flex justify-end', className)}
    >
      <button
        onClick={onClick}
        disabled={disabled || isLoading}
        className={cn(
          'inline-flex items-center justify-center transition-all',
          disabled ? styles.primaryDisabled : styles.primary
        )}
      >
        {isLoading ? (
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
        ) : variant !== 'lc' ? (
          <Check className="w-5 h-5 mr-2" />
        ) : null}
        {buttonLabel}
      </button>
    </motion.div>
  )
}
